import React from 'react';
import HelpTooltip from '../SteppedForm/HelpTooltip';

import { Typography } from '@material-ui/core';
import {
  Person as PersonIcon,
  People as PeopleIcon,
  Apartment as ApartmentIcon
} from '@material-ui/icons';
import { ButtonField, Step } from '../SteppedForm';

const StepOrgtype = (props) => {
  return (
    <Step
      id="orgtype"
      title="Business structure"
      skip={(formdata) => formdata.onboardingFor === 'vehicle'}
      nonext>
      <Typography variant="body1" class="formQuestion">
        What sort of business structure are you applying as?
      </Typography>
      <HelpTooltip title="Select this option if you are signing up as an individual operator, in your own name. You might also be a Driver-Operator">
        <ButtonField
          id="orgtype"
          value="individual"
          label="Individual"
          onClick={
            !props.state.formdata.orgtype || props.state.formdata.orgtype === 'individual'
              ? null
              : () => props.askErase('orgtype', 'individual')
          }
          className="TopIconButton"
          startIcon={<PersonIcon />}
        />
      </HelpTooltip>
      <HelpTooltip
        title="Select this option if you are signing up in Partnership with other people, but you are not registered as a Company. You or any of your partners might also be a Driver-Operator
								You will be prompted to provide details for at least two Partners">
        <ButtonField
          id="orgtype"
          value="partnership"
          label="Partnership"
          className="TopIconButton"
          startIcon={<PeopleIcon />}
        />
      </HelpTooltip>
      <HelpTooltip
        title="Select this option if you are signing up as a Company. You or any of the company directors might also be a Driver-Operator
								You will be prompted to provide details for at least one Director">
        <ButtonField
          id="orgtype"
          value="company"
          label="Company"
          className="TopIconButton"
          startIcon={<ApartmentIcon />}
        />
      </HelpTooltip>
    </Step>
  );
};

export default StepOrgtype;
